<template lang="pug">
  .choice-source
    v-list-item-title.mb-1 Привязка урока (необязательно)
    v-list-item-subtitle.mb-5 Вы можете провести трансляцию в рамках конкретного урока курса
    template(v-if="value.commited")
      v-list-item-subtitle(v-if="!value.lesson") Без привязки
      v-list(
        v-else
      ).sdo-radius
        v-list-item
          v-list-item-avatar
            v-icon(color="secondary lighten-1") mdi-content-copy
          v-list-item-content
            v-list-item-title {{ value.unit.title }}
            v-list-item-subtitle Тема
        v-list-item
          v-list-item-avatar
            v-icon(color="secondary lighten-1") mdi-content-paste
          v-list-item-content
            v-list-item-title {{ value.lesson.name }}
            v-list-item-subtitle Урок

    template(v-if="!value.commited")
      select-unit(
        v-model="unit"
        :course="course.id"
      )
      v-autocomplete(
        v-if="unit"
        v-model="lesson"
        label="Выберите урок"
        item-text="name"
        :items="unit.lessons.filter(({ type }) => type === $conf.LESSON_TYPES.fullTime)"
        return-object
      )
      .mt-5
        v-btn(
          color="grey lighten-3"
          depressed
          @click="commitValue"
        ) Продолжить
</template>

<script>
import SelectUnit from '@/components/InputFields/course-unit/SelectUnit.vue';

export default {
  components: {
    SelectUnit,
  },
  props: {
    value: { type: Object, default: () => ({ commited: false }) },
    course: { type: Object, required: true },
  },
  data() {
    return {
      unit: null,
      lesson: null,
    };
  },
  created() {
    this.fetchUnits();
  },
  methods: {
    async fetchUnits() {
      await this.course.fetchUnits();
    },
    commitValue() {
      return this.$emit('input', {
        unit: this.unit,
        lesson: this.lesson,
        commited: true,
      });
    },
  },
};
</script>
